import { connect, useDispatch } from "react-redux";
import React, { useRef, useState } from "react";
import {
    Button,
    Checkbox,
    Col,
    DatePicker,
    Form,
    Input,
    InputNumber,
    message,
    Row,
    Select,
    TimePicker,
    Typography,
} from "antd";
import { FaMagic } from "react-icons/fa";
import moment from "moment";
import tzlookup from "tz-lookup"
import { useJsApiLoader, Autocomplete } from "@react-google-maps/api";
import { get, pick } from "lodash";
import axios from "axios";
import { URL_API_CREATE_CUSTOM_MOON_PHASE, XKEY_API_CREATE_CUSTOM_MOON_PHASE } from "../../../../config";
import { uniqueID } from "../../Utilities/helper";
import { ARTWORK } from "../../../../types";

const GOOGLE_MAPS_API_KEY = "AIzaSyD2Kty-jKboVyvy-mnWMDd5JUzC4qE5pqc";
const GOOGLE_MAPS_LIBRARIES = ["places"];

const { Option } = Select;
const { Text } = Typography;

const REFERENCE_TYPES = [
    "birthday",
    "wedding_date",
    "anniversary",
    "memorial",
    "baby_birth",
    "date_met",
];

const dateValueProps = (format) => ({
    getValueProps: (value) => ({ value: value ? moment(value, format) : undefined }),
    normalize: (value) => (value ? value.format(format) : null),
});

const MoonPhaseSetting = ({ layer }) => {
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch();
    const form = Form.useFormInstance();
    const autoMap = useRef();
    const { isLoaded } = useJsApiLoader({
        id: "google-map-script",
        googleMapsApiKey: GOOGLE_MAPS_API_KEY,
        libraries: GOOGLE_MAPS_LIBRARIES,
    });

    const OnchangePlacesAutocomplete = () => {
        const AutoMap = autoMap.current;
        const place = AutoMap.state.autocomplete.getPlace();
        const geometry = place && place.geometry && place.geometry.location;
        if (!geometry) return;
        const formatted_address = place.formatted_address || "";
        const timezone = tzlookup(geometry.lat(), geometry.lng());
        dispatch({
            type: ARTWORK.SET_LAYER,
            payload: {
                ...layer,
                formatted_address,
                configsMoonPhase: {
                    ...layer.configsMoonPhase, 
                    timezone,
                    location: {
                        latitude: geometry.lat(),
                        longitude: geometry.lng(),
                    }
                }
            },
        });
    };

    const handleRecreate = async () => {
        setLoading(true)
        const key = "creLayerMoonPhase";
        message.loading({
            content: "Creating image...",
            key,
            duration: 0,
        });
        

        try {
            const req = await axios.post(URL_API_CREATE_CUSTOM_MOON_PHASE, { ...layer.configsMoonPhase }, {
                headers: {
                    'X-ABN-KEY': XKEY_API_CREATE_CUSTOM_MOON_PHASE,
                    'content-type': 'application/json'
                }
            }).then(res => {
                return get(res, 'data.render', false);
            }).catch(() => {
                return false;
            });

            if (!req) {
                message.error({
                    content: "Created new Moon Phase Class failure!",
                    key,
                    duration: 4,
                });
                setLoading(false)
                return;
            }

            const valuesLayer = get(layer, "values", []);
            valuesLayer[0].file = pick({
                id: uniqueID(),
                key: req.png_file.replace(/^\//, '')
            }, ["id", "key"]);
            dispatch({
                type: ARTWORK.SET_LAYER,
                payload: {
                    ...layer,
                    values: valuesLayer,
                    configsMoonPhase: { ...layer.configsMoonPhase }
                },
            });

            message.success({
                content: "Successfully!",
                key,
                duration: 4,
            });
            setLoading(false)
        } catch (error) {
            message.error({
                content: "Failure!!",
                key,
                duration: 4,
            });
            setLoading(false)
        }
        
    }

    return layer.imageMoonPhase ? <>
        <div>
            <Text strong>General</Text>
            <Row gutter={8}>
                <Col span={24}>
                    <Form.Item
                        label="Moon color"
                        name={["configsMoonPhase", "render", "moon_color"]}
                        initialValue={layer.configsMoonPhase.render.moon_color}
                    >
                        <Input className="color-picker-moonphase" type="color" style={{ width: 24, height: 24, padding: 0, transform: 'scale(1.5)' }} />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label="Date"
                        name={["configsMoonPhase", "date"]}
                        rules={[{ required: true, message: "Date is required" }]}
                        {...dateValueProps("YYYY-MM-DD")}
                    >
                        <DatePicker
                            style={{ width: "100%" }}
                            format={"YYYY-MM-DD"}
                        />
                    </Form.Item>
                </Col>
                
                <Col span={12}>
                    <Form.Item
                        label="Time"
                        name={["configsMoonPhase", "time"]}
                        {...dateValueProps("HH:mm:ss")}
                    >
                        <TimePicker
                            style={{ width: "100%" }}
                            format={"HH:mm:ss"}
                            allowClear
                        />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        name={["isDisplaySelectTime"]}
                        valuePropName="checked"
                        initialValue={false}
                    >
                        <Checkbox>Display select time</Checkbox>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={8}>
                <Col span={12} style={{display: 'none'}}>
                    <Form.Item
                        label="Timezone"
                        name={["configsMoonPhase", "timezone"]}
                        extra="IANA timezone name. Leave empty for UTC."
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={12} style={{
                    display: 'none'
                }}>
                    <Form.Item
                        label="Reference type"
                        name={["configsMoonPhase", "reference_type"]}
                        extra="Metadata only, does not affect the image."
                        normalize={(value) => (value || "").slice(0, 64)}
                    >
                        <Select
                            style={{ width: "100%" }}
                            allowClear
                            showSearch
                        >
                            {REFERENCE_TYPES.map((type) => (
                                <Option key={type} value={type}>{type}</Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={8} style={{
                background: "#f1f1f182",
                borderRadius: 3,
                padding: 5
            }}>
                <Col span={24}>
                    <Form.Item label={'Search location: ' + layer.formatted_address} >
                        {isLoaded ? (
                            <Autocomplete ref={autoMap} onPlaceChanged={OnchangePlacesAutocomplete}>
                                <input
                                    type="text"
                                    placeholder="Search a place to fill Latitude/Longitude..."
                                    className={"input_search_google_map"}
                                    style={{ width: "100%" }}
                                />
                            </Autocomplete>
                        ) : (
                            <input
                                type="text"
                                placeholder="Loading Google Maps..."
                                className={"input_search_google_map"}
                                style={{ width: "100%" }}
                                disabled
                            />
                        )}
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label="Latitude"
                        name={["configsMoonPhase", "location", "latitude"]}
                    >
                        <InputNumber style={{ width: "100%" }} min={-90} max={90} step={0.0001} />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label="Longitude"
                        name={["configsMoonPhase", "location", "longitude"]}
                    >
                        <InputNumber style={{ width: "100%" }} min={-180} max={180} step={0.0001} />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        name={["isDisplaySearchLocation"]}
                        valuePropName="checked"
                        initialValue={true}
                    >
                        <Checkbox>Display location search</Checkbox>
                    </Form.Item>
                </Col>
            </Row>

            
            <Row gutter={8}>
                <Col span={12} style={{
                    display: 'none'
                }}>
                    <Form.Item
                        label="Style"
                        name={["configsMoonPhase", "render", "style"]}
                        initialValue={"photoreal"}
                    >
                        <Select style={{ width: "100%" }}>
                            <Option value="solid">Solid</Option>
                            <Option value="photoreal">Photoreal</Option>
                            <Option value="realistic">Realistic</Option>
                            <Option value="minimal">Minimal</Option>
                        </Select>
                    </Form.Item>
                </Col>                
            </Row>
            
            <Row gutter={8} style={{
                display: 'none'
            }}>
                <Col span={12}>
                    <Form.Item
                        label="Width"
                        name={["configsMoonPhase", "render", "width"]}
                        initialValue={2000}
                    >
                        <InputNumber style={{ width: "100%" }} min={256} max={4000} step={1} />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label="Height"
                        name={["configsMoonPhase", "render", "height"]}
                        initialValue={2000}
                        extra="Total pixels (width x height) max 16,000,000."
                    >
                        <InputNumber style={{ width: "100%" }} min={256} max={4000} step={1} />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={8} style={{
                display: 'none'
            }}>
                <Col span={12}>
                    <Form.Item
                        label="Transparent background"
                        name={["configsMoonPhase", "render", "transparent"]}
                        valuePropName="checked"
                        initialValue={true}
                    >
                        <Checkbox />
                    </Form.Item>
                </Col>
                
            </Row>
            
            <Row gutter={8} style={{
                display: 'none'
            }}>
                <Col span={12} style={{
                    display: 'none'
                }}>
                    <Form.Item
                        label="Orientation"
                        name={["configsMoonPhase", "render", "orientation"]}
                        initialValue={"northern"}
                    >
                        <Select style={{ width: "100%" }}>
                            <Option value="northern">Northern</Option>
                            <Option value="southern">Southern</Option>
                            <Option value="auto">Auto (theo Latitude)</Option>
                        </Select>
                    </Form.Item>
                </Col>  
            </Row>

            <Button
                style={{
                    height: "35px",
                    width: "100%",
                    fontSize: "16px",
                    fontWeight: "600",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
                loading={loading}
                type="primary"
                onClick={handleRecreate}
                icon={
                    <FaMagic
                        style={{
                            marginRight: 3,
                        }}
                    />
                }
            >
                Recreate
            </Button>
        </div>
    </> : null;
}


export default connect((state) => ({
  workspace: state.artwork.workspace,
}))(MoonPhaseSetting);
